import React from 'react';
import { motion } from 'framer-motion';
import Navigation from './Navigation';
import MorningTide from './MorningTide';
import Footer from './Footer';
import workshopImage from '../images/events/saturday-self-care-room.jpg';
import festivalBoothOne from '../images/events/kids-fun-festival-booth-1.png';
import festivalBoothTwo from '../images/events/kids-fun-festival-booth-2.png';
import flyerImage from '../images/events/chipotle-fundraiser-flyer.png';
import chipotleRestaurant from '../images/events/chipotle-restaurant.png';
import './Page.css';
import './Events.css';

const reveal = {
  hidden: { opacity: 0, y: 36 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease: [0.2, 0.8, 0.2, 1] } },
};

const MARQUEE = ['Connection', 'Mental health', 'Impact', 'Community'];

const Events = () => {
  return (
    <div className="page events-page">
      <MorningTide />
      <Navigation />
      <main className="page-content events-content">
        <motion.header className="events-hero" initial="hidden" animate="visible" variants={reveal}>
          <span className="events-eyebrow"><i /> gather · connect · give back <i /></span>
          <h1 className="page-title events-title">Events</h1>
          <p className="events-subtitle">Community moments that turn conversation into care—from fundraisers to workshops and everything between.</p>
        </motion.header>

        {/* 01 — Upcoming */}
        <motion.section className="event-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={reveal}>
          <div className="events-section-heading">
            <div><span className="events-section-number">01</span><h2>Upcoming</h2></div>
            <p>What’s next for EarMeOut.</p>
          </div>

          <article className="upcoming-event-card">
            <div className="upcoming-event-copy">
              <span className="upcoming-label">September 5, 2026 · 10:30 AM–12 PM</span>
              <h3>Saturday Self-Care Workshop</h3>
              <p>A low-pressure morning for kids to hang out, make things, and take a break. We’ll have origami, simple crafts, games, and plenty of room to just chill.</p>
              <div className="upcoming-details">
                <div><span>For</span><strong>Children &amp; families</strong></div>
                <div><span>Activities</span><strong>Origami · crafts · games</strong></div>
                <div><span>Location</span><strong>Cupertino Library: Room 201 10:30 - 12</strong></div>
              </div>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdVvU6FvKWP3XBKlqp2Xkw69UfoJKnncitxJ0AEOLTgW0VWJQ/viewform" target="_blank" rel="noreferrer">Register for the workshop <span>↗</span></a>
            </div>
            <div className="upcoming-event-images">
              <figure><img src={workshopImage} alt="Bright community hall arranged with round tables and chairs" /></figure>
            </div>
          </article>
        </motion.section>

        {/* 02 — Past events */}
        <motion.section className="event-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.1 }} variants={reveal}>
          <div className="events-section-heading">
            <div><span className="events-section-number">02</span><h2>Past events</h2></div>
            <p>Moments we’re proud to have shared.</p>
          </div>

          {/* Memorial Park — community booth */}
          <article className="past-event-feature festival-event-feature">
            <div className="past-event-copy festival-event-copy">
              <span className="festival-label">August 22, 2026 · Cupertino</span>
              <h3>A day at Memorial Park.</h3>
              <p className="past-event-lede">We met local families, shared what EarMeOut is building, and made space for honest conversations through a hands-on community booth.</p>
              <div className="festival-details">
                <div><span>Event</span><strong>Celebrating International Diversity</strong></div>
                <div><span>Time</span><strong>10 AM–4 PM</strong></div>
                <div><span>Place</span><strong>Memorial Park</strong></div>
              </div>
            </div>
            <div className="festival-event-gallery">
              <figure className="festival-photo festival-photo-primary"><img src={festivalBoothOne} alt="EarMeOut team welcoming families at its community booth" /></figure>
              <figure className="festival-photo festival-photo-secondary"><img src={festivalBoothTwo} alt="Children making origami crafts at the EarMeOut booth" /></figure>
            </div>
          </article>

          {/* Chipotle — fundraiser */}
          <article className="past-event-feature">
            <span className="event-glow" aria-hidden="true" />
            <div className="past-event-gallery">
              <div className="event-flyer-frame">
                <span className="image-corner image-corner-top" aria-hidden="true" />
                <span className="image-corner image-corner-bottom" aria-hidden="true" />
                <img src={flyerImage} alt="Do Good with Chipotle fundraiser flyer for EarMeOut" />
              </div>
              <figure className="event-memory-frame">
                <img src={chipotleRestaurant} alt="Community members gathered inside Chipotle Cupertino" />
                <figcaption><span />Cupertino, CA</figcaption>
              </figure>
            </div>
            <div className="past-event-copy">
              <div className="event-status-row">
                <span className="event-complete-badge"><i />Completed</span>
                <span className="event-type">Fundraiser</span>
              </div>
              <span className="events-kicker">Do good with Chipotle</span>
              <h3>Chipotle × EarMeOut</h3>
              <p className="past-event-lede">Our community came together over dinner to support accessible mental-health conversations—one burrito at a time.</p>
              <div className="event-facts">
                <div><span>When</span><strong>June 6, 2026</strong><small>5:00–9:00 PM</small></div>
                <div><span>Where</span><strong>Chipotle Cupertino</strong><small>10385 S De Anza Blvd</small></div>
              </div>
              <div className="event-recap-note">
                <span>♥</span>
                <p>Thank you to everyone who ordered, showed the flyer, shared the fundraiser, or simply stopped by.</p>
              </div>
            </div>
          </article>
        </motion.section>

        <div className="event-marquee" aria-hidden="true">
          <div>
            {[...MARQUEE, ...MARQUEE, ...MARQUEE, ...MARQUEE].map((item, i) => (
              <React.Fragment key={i}><span>{item}</span><i>✦</i></React.Fragment>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Events;
